export default __webpack_public_path__ + "locales/ja-JP/ChangeUserStatusDialog.json?hash=ce8c48461c7a6a5246685aa35616cd44";